const AppConfig = {
  // মূল Flask API সার্ভার
  API_BASE_URL: 'https://alifkart-server.sparkx-ai.shop/',
  CompanyName: 'Alif Kart',
  phoneNumber: '01628378486',
  contactEmail: 'hamidullahjessore@gmail.com',
  // WhatsApp লিঙ্ক
  WhatsAppLink: 'https://wa.me/01628378486',
  WhatsAppNumber: '+8801628378486',
  // Facebook Messenger লিঙ্ক
  MessengerLink: 'https://m.me/alifkart',
  // WhatsApp ডিফল্ট মেসেজ
  WhatsAppDefaultMessage: 'Hello! I visited your website and would like some information.',
  DeliveryManURL: 'https://alifkart-server.sparkx-ai.shop/delivery-man',
  WELCOME_COUPON_CODE: 'WELCOME10', // নতুন ব্যবহারকারীদের জন্য
};

export default AppConfig;